<mat-accordion class="faq">
  <mat-expansion-panel
    class="faq__item"
    [hideToggle]="true"
    *ngFor="let faq of faqs; let i = index"
    [expanded]="faq.opened"
    [ngClass]="{
      'faq--image': faq.image,
      'faq--hideFirstTopBorder': faq.hideFirstTopBorder
    }"
  >
    <mat-expansion-panel-header
      class="faq__header"
      [collapsedHeight]="'auto'"
      [expandedHeight]="'auto'"
      (click)="toggle(i)"
    >
      <mat-panel-title class="faq__title mapfre-fs-s mapfre-fw-400 dark">
        {{ faq.question }}
      </mat-panel-title>
      <ion-icon
        class="faq__icon"
        [hidden]="indexOpen === i"
        name="add-circle"
        color="medium"
        slot="end"
      ></ion-icon>
      <ion-icon
        class="faq__icon"
        [hidden]="!(indexOpen === i)"
        name="remove-circle"
        color="medium"
        slot="end"
      ></ion-icon>
    </mat-expansion-panel-header>

    <div class="faq__content">
      <div class="mapfre-fs-xs-r medium-dark" [innerHTML]="faq.answer"></div>
      <ng-container *ngIf="faq.image">
        <img
          class="mapfre-show-desktop"
          [src]="'assets/images/faq/' + faq.image + '-desktop.png'"
          [srcset]="
            'assets/images/faq/' +
            faq.image +
            '-desktop@2x.jpg 2x, assets/images/faq/' +
            faq.image +
            '-desktop@3x.png 3x'
          "
          alt="Imagen del FAQ"
        />
        <img
          class="mapfre-show-tablet"
          [src]="'assets/images/faq/' + faq.image + '-tablet.png'"
          [srcset]="
            'assets/images/faq/' +
            faq.image +
            '-tablet@2x.png 2x, assets/images/faq/' +
            faq.image +
            '-tablet@3x.png 3x'
          "
          alt="Imagen del FAQ"
        />
        <img
          class="mapfre-show-mobile"
          [src]="'assets/images/faq/' + faq.image + '-mobile.png'"
          [srcset]="
            'assets/images/faq/' +
            faq.image +
            '-mobile@2x.png 2x, assets/images/faq/' +
            faq.image +
            '-mobile@3x.png 3x'
          "
          alt="Imagen del FAQ"
        />
      </ng-container>
    </div>
  </mat-expansion-panel>
</mat-accordion>
